var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRank2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2832 2.57007C18.2674 1.85753 19.5768 1.81273 20.6016 2.43628L20.8027 2.57007L27.834 7.66089L27.8389 7.66479L34.8535 12.7781C35.9006 13.5416 36.3388 14.8916 35.9404 16.1248L33.2715 24.3855L33.2695 24.3914L30.5732 32.6423C30.1707 33.8742 29.0225 34.7085 27.7266 34.7107L19.0459 34.7253H19.04L10.3594 34.7107C9.0634 34.7085 7.91524 33.8742 7.5127 32.6423L4.81641 24.3914L4.81445 24.3855L2.14551 16.1248C1.74716 14.8916 2.18529 13.5416 3.23242 12.7781L10.2471 7.66479L10.252 7.66089L17.2832 2.57007Z",
    fill: "url(#paint0_linear_6959_66410)",
    stroke: "url(#paint1_linear_6959_66410)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6959_66410",
    x1: 19.043,
    y1: 3.76538,
    x2: 19.043,
    y2: 35.7654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CD9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#267346"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6959_66410",
    x1: 67.043,
    y1: 19.7654,
    x2: 3.04297,
    y2: 19.7654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.471154,
    stopColor: "#267346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E5C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank2);
export default __webpack_public_path__ + "static/media/rank-2.98b2bdfd630d33d972d685e40a60ad33.svg";
export { ForwardRef as ReactComponent };